import React, { useState } from 'react';
import '../style/Kyagu.scss';
// component
import Header from '../components/public/Header';
// React Bootstrap
import { Container, Row, Col, Image, Tab, Nav } from 'react-bootstrap';
// React redux
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
function Monastery({ lang }) {
    const [option1, setOption1] = useState(true);
    const [option2, setOption2] = useState(false);
    const tabList1 = [
        {
            id: 1,
            to: null,
            title: 'དགོན་གནས།'
        },
        {
            id: 2,
            to: '/',
            title: 'གདན་ས་མཐེལ།'
        },
        {
            id: 3,
            to: null,
            title: 'ཀོ་མཚོ།'
        },
        {
            id: 4,
            to: null,
            title: 'ལོ་སྡེའི་དགོན།'
        },
    ]

    const tabList2 = [
        {
            id: 5,
            to: null,
            title: 'རི་དགོན་བཅོ་བརྒྱད།'
        },
        {
            id: 6,
            to: null,
            title: 'ཉིན་དགོན།'
        },
        {
            id: 7,
            to: null,
            title: 'རྒོད་ཚང།'
        },
        {
            id: 8,
            to: null,
            title: 'བེའུ་རུ་བ།'
        },
        {
            id: 9,
            to: null,
            title: 'དགོན་སར་བ།'
        },
        {
            id: 10,
            to: null,
            title: 'རྣ་རོང།'
        },
        {
            id: 11,
            to: null,
            title: 'སྟོང་ནག།།'
        },
        {
            id: 12,
            to: null,
            title: 'ཇབ་པ།'
        },
        {
            id: 13,
            to: null,
            title: 'སྐྱོ་བྲག'
        },
        {
            id: 14,
            to: null,
            title: 'ཤོར་ཕུ།'
        },
        {
            id: 15,
            to: null,
            title: 'ཕུག་པ་བ།'
        },
        {
            id: 16,
            to: null,
            title: 'རོ་ལོ།'
        },
        {
            id: 17,
            to: null,
            title: 'ཤར་པ།'
        },
        {
            id: 18,
            to: null,
            title: 'རྒིས་སྣ།'
        },
        {
            id: 19,
            to: null,
            title: 'སོ་རག'
        },
        {
            id: 20,
            to: null,
            title: 'ཁོ་བ་ཕུག་པ།'
        },
        {
            id: 21,
            to: null,
            title: 'རི་ཕ་བ་ནི།'
        },
        {
            id: 22,
            to: null,
            title: 'དེང་ཐོག་པ་ནི།'
        },
        {
            id: 23,
            to: null,
            title: 'རྫ་རི་བ་ནི།'
        },
    ]
    return (
        <>
            <Header />
            <Container className='kyagu'>
                <div className='kyaguBody pt-4 pr-5 pl-5'>
                    <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                        <Col className='align-items-center'>
                        </Col>
                    </Row>
                    {
                        lang === 'CH' ? (
                            // chinese Section
                            <>
                                <Row>
                                    <Col>
                                        <h3 className='text-left text-secondary'>Chinese Section</h3>

                                    </Col>
                                </Row>
                            </>
                        ) : (
                                // Tibetan Section
                                <>
                                    {
                                        option1 ? (
                                            <>
                                                <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                                                    <Col className='align-items-center'>
                                                        {/* Header Image */}
                                                        {/* Title */}
                                                        <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                                                            དགོན་གནས།
                                                        </h3>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Tab.Container id='left-tabs' defaultActiveKey='0'>
                                                            <Row>
                                                                <Col sm={5} md={3}>
                                                                    <Nav variant='pills' className='flex-column '>
                                                                        {/* Tabs */}
                                                                        {
                                                                            tabList1.map((tabItem, index) => {
                                                                                return (
                                                                                    <Nav.Item className='navItem' key='id'>
                                                                                        <Nav.Link eventKey={index}>
                                                                                            <h4>{tabItem.title}</h4>
                                                                                        </Nav.Link>
                                                                                    </Nav.Item>)
                                                                            })
                                                                        }
                                                                        <Nav.Item className='navItem' onClick={() => {
                                                                            setOption1(false);
                                                                            setOption2(true);
                                                                        }}>
                                                                            <Nav.Link >
                                                                                <h4>རི་དགོན་བཅོ་བརྒྱད། ➡️</h4>
                                                                            </Nav.Link>
                                                                        </Nav.Item>
                                                                    </Nav>
                                                                </Col>

                                                                {/* Content */}
                                                                <Col sm={7} md={9}>
                                                                    <Tab.Content className='tabContent'>
                                                                        <Tab.Pane eventKey='1' className='tabPane'>

                                                                            <p>
                                                                                <h1>བོད་ཡིག་</h1>
                                                                            </p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='second' className='tabPane'>
                                                                            <p>i am Singapore</p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='third' className='tabPane'>
                                                                            <p>i am tibet</p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='forth' className='tabPane'>
                                                                            <p>i am tibet</p>
                                                                        </Tab.Pane>
                                                                    </Tab.Content>
                                                                </Col>
                                                            </Row>
                                                        </Tab.Container>
                                                    </Col>
                                                </Row>
                                            </>
                                        ) : option2 ? (
                                            <>
                                                <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                                                    <Col className='align-items-center'>
                                                        {/* Header Image */}
                                                        {/* Title */}
                                                        <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                                                            དགོན་གནས།
                                                        </h3>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Tab.Container id='left-tabs' defaultActiveKey='0'>
                                                            <Row>
                                                                <Col sm={5} md={3}>
                                                                    <Nav variant='pills' className='flex-column '>
                                                                        {/* Tabs */}
                                                                        <Nav.Item className='navItem' onClick={() => {
                                                                            setOption1(true);
                                                                            setOption2(false);
                                                                        }}>
                                                                            <Nav.Link >
                                                                                <h4>དགོན་གནས།  🔙️</h4>
                                                                            </Nav.Link>
                                                                        </Nav.Item>
                                                                        {
                                                                            tabList2.map((tabItem, index) => {
                                                                                return (
                                                                                    <Nav.Item className='navItem' key='id'>
                                                                                        <Nav.Link eventKey={index}>
                                                                                            <h4>{tabItem.title}</h4>
                                                                                        </Nav.Link>
                                                                                    </Nav.Item>)
                                                                            })
                                                                        }

                                                                    </Nav>
                                                                </Col>

                                                                {/* Content */}
                                                                <Col sm={7} md={9}>
                                                                    <Tab.Content className='tabContent'>
                                                                        <Tab.Pane eventKey='1' className='tabPane'>

                                                                            <p>
                                                                                <h1>བོད་ཡིག་</h1>
                                                                            </p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='second' className='tabPane'>
                                                                            <p>i am Singapore</p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='third' className='tabPane'>
                                                                            <p>i am tibet</p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='forth' className='tabPane'>
                                                                            <p>i am tibet</p>
                                                                        </Tab.Pane>
                                                                    </Tab.Content>
                                                                </Col>
                                                            </Row>
                                                        </Tab.Container>
                                                    </Col>
                                                </Row>
                                            </>
                                        ) : (
                                                    null
                                                )
                                    }

                                </>
                            )
                    }

                </div>
            </Container>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        lang: state.lang.lang,
    };
};

export default connect(mapStateToProps)(Monastery);
